import { Flex, Grid, Tooltip } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import _, { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Color } from '../../../Common/Color'
import { t } from 'i18next'
import PublicContext from '../../PublicContext'
import MobileBoxSlotList from '../Mobile/MobileBoxSlotList'
import ComputerBoxSlotList from '../Computer/ComputerBoxSlotList'
import TabletBoxSlotList from '../Tablet/TabletBoxSlotList'
import { screenSize } from '../../../Common/Common'
const { useBreakpoint } = Grid

const daysListStyle = {
  xs: {
    fontSize: '20px',
    marginTop: '1em',
    marginBottom: '0.5em',
    textAlign: 'center'
  },
  other: {
    fontSize: '20px',
    marginTop: '1em',
    marginBottom: '0.5em'
  }
}

export const slotTitle = (day) => {
  if (dayjs(day).isSame(dayjs(), 'day')) {
    return t('Public.BoxList.today')
  } else {
    return dayjs(day).format('dddd D MMMM')
  }
}

export default function BoxSlotList () {
  const screens = useBreakpoint()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [days, setDays] = useState([])
  const { box, setSiderTitle, getNextSlots } = useContext(PublicContext)

  const availableSlot = (slot) => (
    <div
      className='hoverable'
      key={dayjs(slot.time).format('dd/mm/yyyy HH:mm')}
      onClick={() => onClick(slot.time)}
      style={{
        textAlign: 'center',
        width: '115px',
        display: 'inline-block',
        fontSize: '16px',
        border: '1px solid black',
        borderRadius: '2em',
        padding: '0.4em 1em',
        '--hover-color': Color.red,
        '--hover-border-color': Color.red,
        cursor: 'pointer'
      }}>
      {dayjs(slot.time).format('HH:mm')}
    </div>
  )

  const unavailableSlot = (slot) => (
    <Tooltip title={t('Public.BoxPage.unavailable')}>
      <div
        className='hoverable'
        key={dayjs(slot.time).format('dd/mm/yyyy HH:mm')}
        style={{
          textAlign: 'center',
          width: '115px',
          display: 'inline-block',
          fontSize: '16px',
          border: '1px solid black',
          borderRadius: '2em',
          padding: '0.4em 1em',
          backgroundColor: 'lightgrey'
        }}>
        {dayjs(slot.time).format('HH:mm')}
      </div>
    </Tooltip>
  )

  useEffect(() => {
    if (box) {
      const slots = box.next_slots.filter((slot) => dayjs(slot.time) >= dayjs())
      setDays(_.groupBy(slots, (slot) => {
        return dayjs(slot.time).format('YYYY-MM-DD')
      }))
    }
  }, [box])

  const onClick = (slot) =>
    navigate(`/box/${box.id}/slot_create?date=${dayjs(slot).toString()}`)

  const hourList = (slots) => (
    <Flex gap='1em' wrap>
      {
        slots.map((slot) => (
          slot.available ? availableSlot(slot) : unavailableSlot(slot)
        ))
      }
    </Flex>
  )

  const more = () => {
    const newValue = Object.keys(days).length
    getNextSlots(dayjs().add(newValue, 'day').toString())
  }

  const dayDisplay = (day) => (
    <div key={slotTitle(day)} style={{ margin: '0 4%' }}>
      <div style={screens.xs ? daysListStyle.xs : daysListStyle.other}>
        {capitalize(slotTitle(day))}
      </div>
      {hourList(days[day])}
    </div>
  )

  const daysList = (slotList) => {
    const displayedDays = Object.keys(slotList)
    const days = _.take(displayedDays, displayedDays.length)
    return days.map(dayDisplay)
  }

  useEffect(() => {
    setSiderTitle(t('Public.BoxPage.title'))
  }, [])

  const slotsList = {
    Mobile: MobileBoxSlotList,
    Computer: ComputerBoxSlotList,
    Tablet: TabletBoxSlotList
  }

  const ResponsiveList = slotsList[screenSize()]

  return (
    <ResponsiveList box={box} daysList={daysList(days)} more={more} />
  )
}
